import { render, staticRenderFns } from "./editTreeDialog.vue?vue&type=template&id=6b688828&scoped=true&"
import script from "./editTreeDialog.vue?vue&type=script&lang=js&"
export * from "./editTreeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b688828",
  null
  
)

export default component.exports